//Default Buttons
export const RAISED_DEFAULT_BUTTONS = [
  {
    text: "Add ",
    code: ".btn-pill",
  },
  {
    text: " and ",
    code: ".btn-air*",
  },
  {
    text: " class for raised button",
  },
];

export const RAISED_DEFAULT_BUTTONS_LIST = [
  {
    id: 2,
    color: "secondary",
    className: "btn-air-secondary",
    btnText: "Secondary Button",
    tooltipText: "btn btn-pill btn-secondary btn-air-secondary",
  },
  {
    id: 3,
    color: "success",
    className: "btn-air-success",
    btnText: "Success Button",
    tooltipText: "btn btn-pill btn-success btn-air-success",
  },
  {
    id: 4,
    color: "info",
    className: "btn-air-info",
    btnText: "Info Button",
    tooltipText: "btn btn-pill btn-info btn-air-info",
  },
  {
    id: 5,
    color: "warning",
    className: "btn-air-warning",
    btnText: "Warning Button",
    tooltipText: "btn btn-pill btn-warning btn-air-warning",
  },
  {
    id: 6,
    color: "danger",
    className: "btn-air-danger",
    btnText: "Danger Button",
    tooltipText: "btn btn-pill btn-danger btn-air-danger",
  },
  {
    id: 7,
    color: "light",
    className: "btn-air-light",
    btnText: "Light Button",
    tooltipText: "btn btn-pill btn-light btn-air-light",
  },
];

//LargeButtons
export const RAISED_LARGE_BUTTONS = [
  {
    text: "Add ",
    code: ".btn-pill,.btn-air*",
  },
  {
    text: " and ",
    code: ".btn-lg",
  },
  {
    text: " class for large buttons",
  },
];

export const ERAISED_LARGE_BUTTONS_LIST = [
  {
    id: 9,
    color: "secondary",
    className: "btn-air-secondary",
    btnText: "Secondary Button",
    tooltipText: "btn btn-pill btn-secondary btn-air-secondary btn-lg",
  },
  {
    id: 10,
    color: "success",
    className: "btn-air-success",
    btnText: "Success Button",
    tooltipText: "btn btn-pill btn-success btn-air-success btn-lg",
  },
  {
    id: 11,
    color: "info",
    className: "btn-air-info",
    btnText: "Info Button",
    tooltipText: "btn btn-pill btn-info btn-air-info btn-lg",
  },
  {
    id: 12,
    color: "warning",
    className: "btn-air-warning",
    btnText: "Warning Button",
    tooltipText: "btn btn-pill btn-warning btn-air-warning btn-lg",
  },
  {
    id: 13,
    color: "danger",
    className: "btn-air-danger",
    btnText: "Danger Button",
    tooltipText: "btn btn-pill btn-danger btn-air-danger btn-lg",
  },
  {
    id: 14,
    color: "light",
    className: "btn-air-light",
    btnText: "Light Button",
    tooltipText: "btn btn-pill btn-light btn-air-light btn-lg",
  },
];

export const RAISED_SMALL_BUTTONS = [
  {
    text: "Add ",
    code: ".btn-pill,.btn-air*",
  },
  {
    text: " and ",
    code: ".btn-sm",
  },
  {
    text: " class for small buttons",
  },
];

export const RAISED_SMALL_BUTTONS_LIST = [
  {
    id: 16,
    color: "secondary",
    className: "btn-air-secondary",
    btnText: "Secondary Button",
    tooltipText: "btn btn-square btn-secondary btn-air-secondary btn-sm",
  },
  {
    id: 17,
    color: "success",
    className: "btn-air-success",
    btnText: "Success Button",
    tooltipText: "btn btn-pill btn-success btn-air-success btn-sm",
  },
  {
    id: 18,
    color: "info",
    className: "btn-air-info",
    btnText: "Info Button",
    tooltipText: "btn btn-pill btn-info btn-air-info btn-sm",
  },
  {
    id: 19,
    color: "warning",
    className: "btn-air-warning",
    btnText: "Warning Button",
    tooltipText: "btn btn-pill btn-warning btn-air-warning btn-sm",
  },
  {
    id: 20,
    color: "danger",
    className: "btn-air-danger",
    btnText: "Danger Button",
    tooltipText: "btn btn-pill btn-danger btn-air-danger btn-sm",
  },
  {
    id: 21,
    color: "light",
    className: "btn-air-light",
    btnText: "Light Button",
    tooltipText: "btn btn-pill btn-light btn-air-light btn-sm",
  },
];

//Extra Small Button
export const RAISED_EXTRA_SMALL_BUTTONS = [
  {
    text: "Add ",
    code: ".btn-pill,.btn-air*",
  },
  {
    text: " and ",
    code: ".btn-xs",
  },
  {
    text: " class for extra small size buttons",
  },
];

export const RAISED_EXTRA_SMALL_BUTTONS_LIST = [
  {
    id: 23,
    color: "secondary",
    className: "btn-air-secondary",
    btnText: "Secondary Button",
    tooltipText: "btn btn-pill btn-secondary btn-air-secondary btn-xs",
  },
  {
    id: 24,
    color: "success",
    className: "btn-air-success",
    btnText: "Success Button",
    tooltipText: "btn btn-pill btn-success btn-air-success btn-xs",
  },
  {
    id: 25,
    color: "info",
    className: "btn-air-info",
    btnText: "Info Button",
    tooltipText: "btn btn-pill btn-info btn-air-info btn-xs",
  },
  {
    id: 26,
    color: "warning",
    className: "btn-air-warning",
    btnText: "Warning Button",
    tooltipText: "btn btn-pill btn-warning btn-air-warning btn-xs",
  },
  {
    id: 27,
    color: "danger",
    className: "btn-air-danger",
    btnText: "Danger Button",
    tooltipText: "btn btn-pill btn-danger btn-air-danger btn-xs",
  },
  {
    id: 28,
    color: "light",
    className: "btn-air-light",
    btnText: "Light Button",
    tooltipText: "btn btn-pill btn-light btn-air-light btn-xs",
  },
];

//Active Button
export const RAISED_ACTIVE_BUTTONS = [
  {
    text: "Add ",
    code: ".active",
  },
  {
    text: " class for active state",
  },
];

export const RAISED_ACTIVE_BUTTONS_LIST = [
  {
    id: 30,
    color: "secondary",
    className: "btn-air-secondary",
    btnText: "Active",
    tooltipText: "btn btn-secondary btn-air-secondary active",
  },
  {
    id: 31,
    color: "success",
    className: "btn-air-success",
    btnText: "Active",
    tooltipText: "btn btn-success btn-air-success active",
  },
  {
    id: 32,
    color: "info",
    className: "btn-air-info",
    btnText: "Active",
    tooltipText: "btn btn-info btn-air-info active",
  },
  {
    id: 33,
    color: "warning",
    className: "btn-air-warning",
    btnText: "Active",
    tooltipText: "btn btn-warning btn-air-warning active",
  },
  {
    id: 34,
    color: "danger",
    className: "btn-air-danger",
    btnText: "Active",
    tooltipText: "btn btn-danger btn-air-danger active",
  },
  {
    id: 35,
    color: "light",
    className: "btn-air-light",
    btnText: "Active",
    tooltipText: "btn btn-light btn-air-light active",
  },
];

//Disabled Button
export const RAISED_DISABLE_BUTTONS = [
  {
    text: "Add ",
    code: ".disabled",
  },
  {
    text: " class or ",
    code: "disabled='disabled'",
  },
  {
    text: " attribute for disabled button",
  },
];

export const RAISED_DISABLE_BUTTONS_LIST = [
  {
    color: "secondary",
    className: "btn-air-secondary",
  },
  {
    color: "success",
    className: "btn-air-success",
  },
  {
    color: "info",
    className: "btn-air-info",
  },
  {
    color: "warning",
    className: "btn-air-warning",
  },
  {
    color: "danger",
    className: "btn-air-danger",
  },
  {
    color: "light",
    className: "text-dark btn-air-light",
  },
];

//Outline Buttons
export const RAISED_OUTLINE_BUTTONS = [
  {
    text: "Add ",
    code: ".btn-pill,.btn-air*",
  },
  {
    text: " and ",
    code: ".btn-outline-*",
  },
  {
    text: " class for button with outline",
  },
];

export const RAISED_OUTLINE_BUTTONS_LIST = [
  {
    id: 41,
    color: "secondary",
    className: "btn-air-secondary",
    btnText: "Secondary Button",
    tooltipText: "btn btn-pill btn-outline-secondary btn-air-secondary",
  },
  {
    id: 42,
    color: "success",
    className: "btn-air-success",
    btnText: "Success Button",
    tooltipText: "btn btn-pill btn-outline-success btn-air-success",
  },
  {
    id: 43,
    color: "info",
    className: "btn-air-info",
    btnText: "Info Button",
    tooltipText: "btn btn-pill btn-outline-info btn-air-info",
  },
  {
    id: 44,
    color: "warning",
    className: "btn-air-warning",
    btnText: "Warning Button",
    tooltipText: "btn btn-pill btn-outline-warning btn-air-warning",
  },
  {
    id: 45,
    color: "danger",
    className: "btn-air-danger",
    btnText: "Danger Button",
    tooltipText: "btn btn-pill btn-outline-danger btn-air-danger",
  },
  {
    id: 46,
    color: "light",
    btnText: "Light Button",
    tooltipText: "btn btn-pill btn-outline-light btn-air-light",
    className: "text-dark btn-air-light",
  },
];

//Bold Outline Buttons
export const RAISED_BOLD_OUTLINE_BUTTONS = [
  {
    text: "Add ",
    code: ".btn-pill,.btn-air*",
  },
  {
    text: " and ",
    code: ".btn-outline-*-2x",
  },
  {
    text: " class for button with bold outline",
  },
];

export const RAISED_BOLD_OUTLINE_BUTTONS_LIST = [
  {
    id: 48,
    color: "secondary-2x",
    className: "btn-air-secondary",
    btnText: "Secondary Button",
    tooltipText: "btn btn-pill btn-outline-secondary-2x btn-air-secondary",
  },
  {
    id: 49,
    color: "success-2x",
    className: "btn-air-success",
    btnText: "Success Button",
    tooltipText: "btn btn-pill btn-outline-success-2x btn-air-success",
  },
  {
    id: 50,
    color: "info-2x",
    className: "btn-air-info",
    btnText: "Info Button",
    tooltipText: "btn btn-pill btn-outline-info-2x btn-air-info",
  },
  {
    id: 51,
    color: "warning-2x",
    className: "btn-air-warning",
    btnText: "Warning Button",
    tooltipText: "btn btn-pill btn-outline-warning-2x btn-air-warning",
  },
  {
    id: 52,
    color: "danger-2x",
    className: "btn-air-danger",
    btnText: "Danger Button",
    tooltipText: "btn btn-pill btn-outline-danger-2x btn-air-danger",
  },
  {
    id: 53,
    color: "light-2x",
    btnText: "Light Button",
    tooltipText: "btn btn-pill btn-outline-light-2x btn-air-light",
    className: "text-dark btn-air-light",
  },
];

//large Outline Buttons
export const RAISED_LARGE_OUTLINE_BUTTONS = [
  {
    text: "Add ",
    code: ".btn-pill,.btn-air-*,.btn-outline-*",
  },
  {
    text: " and ",
    code: ".btn-lg",
  },
  {
    text: " class for large button",
  },
];

export const RAISED_LARGE_OUTLINE_BUTTONS_LIST = [
  {
    id: 55,
    color: "secondary",
    className: "btn-air-secondary",
    btnText: "Secondary Button",
    tooltipText: "btn btn-pill btn-outline-secondary btn-lg btn-air-secondary",
  },
  {
    id: 56,
    color: "success",
    className: "btn-air-success",
    btnText: "Success Button",
    tooltipText: "btn btn-pill btn-outline-success btn-lg btn-air-success",
  },
  {
    id: 57,
    color: "info",
    className: "btn-air-info",
    btnText: "Info Button",
    tooltipText: "btn btn-pill btn-outline-info btn-lg btn-air-info",
  },
  {
    id: 58,
    color: "warning",
    className: "btn-air-warning",
    btnText: "Warning Button",
    tooltipText: "btn btn-pill btn-outline-warning btn-lg btn-air-warning",
  },
  {
    id: 59,
    color: "danger",
    className: "btn-air-danger",
    btnText: "Danger Button",
    tooltipText: "btn btn-pill btn-outline-danger btn-lg btn-air-danger",
  },
  {
    id: 60,
    color: "light",
    btnText: "Light Button",
    tooltipText: "btn btn-pill btn-outline-light btn-lg btn-air-light",
    className: "text-dark btn-air-light",
  },
];

//Small Outline Buttons
export const RAISED_SMALL_OUTLINE_BUTTONS = [
  {
    text: "Add ",
    code: ".btn-pill,byn-air*,.btn-outline-*",
  },
  {
    text: " and ",
    code: ".btn-sm",
  },
  {
    text: " class for small button",
  },
];

export const RAISED_SMALL_OUTLINE_BUTTONS_LIST = [
  {
    id: 62,
    color: "secondary",
    className: "btn-air-secondary",
    btnText: "Secondary Button",
    tooltipText: "btn btn-pill btn-outline-secondary btn-sm btn-air-secondary",
  },
  {
    id: 63,
    color: "success",
    className: "btn-air-success",
    btnText: "Success Button",
    tooltipText: "btn btn-pill btn-outline-success btn-sm btn-air-success",
  },
  {
    id: 64,
    color: "info",
    className: "btn-air-info",
    btnText: "Info Button",
    tooltipText: "btn btn-pill btn-outline-info btn-sm btn-air-info",
  },
  {
    id: 65,
    color: "warning",
    className: "btn-air-warning",
    btnText: "Warning Button",
    tooltipText: "btn btn-pill btn-outline-warning btn-sm btn-air-warning",
  },
  {
    id: 66,
    color: "danger",
    className: "btn-air-danger",
    btnText: "Danger Button",
    tooltipText: "btn btn-pill btn-outline-danger btn-sm btn-air-danger",
  },
  {
    id: 67,
    color: "light",
    btnText: "Light Button",
    tooltipText: "btn btn-pill btn-outline-light btn-sm btn-air-light",
    className: "text-dark btn-air-light",
  },
];

//Extra Small Outline Buttons
export const RAISED_EXTRA_SMALL_OUTLINE_BUTTONS = [
  {
    text: "Add ",
    code: ".btn-pill,btn-air*,.btn-outline-*",
  },
  {
    text: " and ",
    code: ".btn-xs",
  },
  {
    text: " class for extra small button",
  },
];

export const RAISED_EXTRA_SMALL_OUTLINE_BUTTONS_LIST = [
  {
    id: 69,
    color: "secondary",
    className: "btn-air-secondary",
    btnText: "Secondary Button",
    tooltipText: "btn btn-pill btn-outline-secondary btn-xs",
  },
  {
    id: 70,
    color: "success",
    className: "btn-air-success",
    btnText: "Success Button",
    tooltipText: "btn btn-pill btn-outline-success btn-xs",
  },
  {
    id: 71,
    color: "info",
    className: "btn-air-info",
    btnText: "Info Button",
    tooltipText: "btn btn-pill btn-outline-info btn-xs",
  },
  {
    id: 72,
    color: "warning",
    className: "btn-air-warning",
    btnText: "Warning Button",
    tooltipText: "btn btn-pill btn-outline-warning btn-xs",
  },
  {
    id: 73,
    color: "danger",
    className: "btn-air-danger",
    btnText: "Danger Button",
    tooltipText: "btn btn-pill btn-outline-danger btn-xs",
  },
  {
    id: 74,
    color: "light",
    btnText: "Light Button",
    tooltipText: "btn btn-pill btn-outline-light btn-xs",
    className: "text-dark btn-air-light",
  },
];

//Gradien Button
export const RAISED_GRADIEN_BUTTONS = [
  {
    text: "Add ",
    code: ".btn-pill,btn-air*",
  },
  {
    text: " and ",
    code: ".btn-*-gradien",
  },
  {
    text: " class for gradien button",
  },
];

export const RAISED_GRADIEN_BUTTONS_LIST = [
  {
    id: 76,
    color: "secondary-gradien",
    className: "btn-air-secondary",
    btnText: "Secondary Button",
    tooltipText: "btn btn-pill btn-secondary-gradien btn-air-secondary",
  },
  {
    id: 77,
    color: "success-gradien",
    className: "btn-air-success",
    btnText: "Success Button",
    tooltipText: "btn btn-pill btn-success-gradien btn-air-success",
  },
  {
    id: 78,
    color: "info-gradien",
    className: "btn-air-info",
    btnText: "Info Button",
    tooltipText: "btn btn-pill btn-info-gradien btn-air-info",
  },
  {
    id: 79,
    color: "warning-gradien",
    className: "btn-air-warning",
    btnText: "Warning Button",
    tooltipText: "btn btn-pill btn-warning-gradien btn-air-warning",
  },
  {
    id: 80,
    color: "danger-gradien",
    className: "btn-air-danger",
    btnText: "Danger Button",
    tooltipText: "btn btn-pill btn-danger-gradien btn-air-danger",
  },{
    id: 81,
    color: "light-gradien",
    className: "text-dark btn-air-light",
    btnText: "Light Button",
    tooltipText: "btn btn-pill btn-light-gradien btn-air-light",
  },
];